// Server báo một lượt lưu tiến độ (sách / video) không được ghi giờ vì học
// viên đã chạm giới hạn giờ/ngày (`dailyLimitReached`). Layout đang hỏi giờ
// hôm nay mỗi 10 phút — sự kiện này bảo nó hỏi lại NGAY để hiện thông báo đủ
// giờ, thay vì để HV tiếp tục học mà không được tính tới 10 phút.
export const DAILY_LIMIT_EVENT = 'elearning:daily-limit-reached';

const THROTTLE_MS = 60 * 1000;
let lastFiredAt = 0;

export function notifyDailyLimitReached(now = Date.now()) {
  if (now - lastFiredAt < THROTTLE_MS) return false;
  lastFiredAt = now;
  try {
    window.dispatchEvent(new CustomEvent(DAILY_LIMIT_EVENT));
  } catch (_) { /* môi trường không có window */ }
  return true;
}

// Đọc cờ từ response (axios interceptor có lúc trả body, có lúc trả {data}).
export function responseHitDailyLimit(res) {
  return !!(res?.dailyLimitReached || res?.data?.dailyLimitReached);
}

const VN_OFFSET_MS = 7 * 60 * 60 * 1000;

// Ngày theo giờ VN (YYYY-MM-DD) — cùng cách chia ngày với server.
export function vnDateKey(now = Date.now()) {
  return new Date(now + VN_OFFSET_MS).toISOString().slice(0, 10);
}

// Chặn khi server báo đã chạm/vượt, hoặc tổng đã tới giới hạn. Không đoán
// trước: server dừng ghi giờ đúng ở giới hạn và báo `isLimitReached`.
export function shouldBlockFromServer(data) {
  if (!data) return false;
  const { totalTodayTime, timeLimitPerDay, isLimitExceeded, isLimitReached } = data;
  if (isLimitExceeded || isLimitReached) return true;
  return Number(timeLimitPerDay) > 0 && Number(totalTodayTime) >= Number(timeLimitPerDay);
}

// Mili-giây tới 00:01:30 VN kế tiếp — lúc bộ đếm đã sang ngày và job 00:01
// đã mở khoá, để tab mở qua nửa đêm tự gỡ chặn.
export function msUntilNextVnReset(now = Date.now()) {
  const todayResetUtc = Date.parse(`${vnDateKey(now)}T00:01:30+07:00`);
  return todayResetUtc > now ? todayResetUtc - now : todayResetUtc + 24 * 60 * 60 * 1000 - now;
}

// Trạng thái chặn đã lưu (localStorage) thuộc một ngày đã qua.
export function isSavedBlockStale(saved, now = Date.now()) {
  return !!saved?.date && saved.date !== vnDateKey(now);
}

// Overlay khoá đã đóng (sang ngày, hoặc HV bấm "Để sau" — có thể trung tâm
// vừa mở khoá) → trang sách chạy lại bộ ghi giờ; còn khoá thì lượt ghi đầu
// tiên nhận 403 và dừng lại.
export const CAP_CLEARED_EVENT = 'elearning:cap-suspended-cleared';

export function notifyCapCleared() {
  try {
    window.dispatchEvent(new CustomEvent(CAP_CLEARED_EVENT));
  } catch (_) { /* môi trường không có window */ }
}

// 403 CAP_SUSPENDED — tài khoản đang bị khoá do vượt giờ (overlay báo cho HV).
export function isCapSuspendedError(err) {
  return err?.response?.status === 403 && err?.response?.data?.code === 'CAP_SUSPENDED';
}

// Chống lặp overlay khoá: tối đa 1 lần / refireMs, nhưng mở lại ngay khi overlay
// đóng (reset) — HV được mở khoá rồi bị khoá lại vẫn được báo.
export function createCapSuspendedGate(refireMs) {
  let firedAt = null;
  return {
    shouldFire(now = Date.now()) {
      if (firedAt != null && now - firedAt < refireMs) return false;
      firedAt = now;
      return true;
    },
    reset() { firedAt = null; },
  };
}

// Lượt hỏi 00:01:30 lỗi hoặc vẫn còn chặn → hỏi lại sau chừng này (null = thôi,
// chờ lượt poll thường).
const MIDNIGHT_RETRY_MS = [60000, 120000, 300000, 600000, 900000];
export function midnightRetryDelayMs(attempt) {
  return attempt >= 0 && attempt < MIDNIGHT_RETRY_MS.length ? MIDNIGHT_RETRY_MS[attempt] : null;
}

// Overlay 403 CAP_SUSPENDED hiển thị gì. Khoá vĩnh viễn: không đếm ngược,
// không tự tắt (chỉ trung tâm mở được). Khoá trong ngày: đếm tới 00:01.
export function capSuspendedView(detail) {
  if (detail?.permanent) {
    return { title: 'Tài khoản đã bị khoá học trực tuyến', showCountdown: false, autoDismiss: false };
  }
  return { title: 'Đã đạt giới hạn giờ học hôm nay', showCountdown: true, autoDismiss: true };
}
